export default __webpack_public_path__ + "resources/icons/n0-0686.webp";